<script setup lang="ts">
import { computed, provide, useAttrs } from "vue";
import { InputGroupSymbol } from "../../injectionSymbols";
import { cn } from "../../lib/utils";

provide(InputGroupSymbol, true);

defineOptions({ inheritAttrs: false });

const attrs = useAttrs();

const attrsWithoutClasses = computed(() => {
	const { class: _, ...rest } = attrs;
	return rest;
});
</script>

<template>
	<label :class="cn('input-group flex items-center')" v-bind="attrsWithoutClasses">
		<slot />
	</label>
</template>
